import moment, { Moment } from 'moment';
import { DossierId } from '@/dossier/models/AbstractDossier';
import { OutletId } from '@/shared/models/Outlet';
import User, { UserId } from '@/shared/models/User';

export interface RestrictedAccessRecordId {__restrictedAccessRecordId: number;}

export default class RestrictedAccessRecord {
  id!: RestrictedAccessRecordId;
  userId!: UserId;
  dossierId!: DossierId;
  outletId!: OutletId;
  outletDescription = '';
  externalReference: string | null = null;
  appointmentOn: Moment | null = null;
  registrationNumber: string | null = null;
  createdOn = moment();
  createdBy!: User;
}